// extracted by mini-css-extract-plugin
export default {"legend_circle":"styles_legend_circle__QEVZa"};